export const environment = {
  production: false,
  appVersion: '1.0.1750351403', // Will be updated by build script
  useEmulators: false, // Set to true when you want to use Firebase emulators
  firebase: {
    apiKey: "AIzaSyACT0f5BSr3q2J6mGgKDPyIj6VDqLkpGH0",
    authDomain: "strawjar-fcff1.firebaseapp.com",
    projectId: "strawjar-fcff1",
    storageBucket: "strawjar-fcff1.firebasestorage.app",
    messagingSenderId: "584262870564",
    appId: "1:584262870564:web:93080d296d107d2c4a1ab1"
  },
  emulators: {
    auth: { host: 'localhost', port: 9099 },
    firestore: { host: 'localhost', port: 8080 },
    storage: { host: 'localhost', port: 9199 }
  },
  openai: {
    apiKey: "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", // Project-scoped API key
    model: "gpt-image-1" // Updated to match the model in the documentation example
  },
  runware: {
    apiKey: "7vG6LFqi4KYiaAI4cNli7paztlOn1EQr", // Replace with your actual Runware API key
    model: "civitai:267728@345685", // Sticker-specific model from Runware example
    loraModel: "civitai:144142@160130", // LoRA model for stickers
    negativePrompt: "nsfw, 3d, monochrome" // Default negative prompt for stickers
  }
};